import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EditDialogComponent } from '../../../core/components/editDialog/editDialogComponent';
import { EditDialogInstance } from '../../../core/components/editDialog/editDialogService';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TaskInput } from 'src/app/rent-module/shared/entities/taskInput/taskInput';

@Component({
  selector: 'app-task-create-dialog',
  template: `
    <div [formGroup]="taskForm" class="form flex flex-col">
      <nx-edit-select-input
        formControlName="type"
        [label]="'Typ'"
        [options]="selectableTaskTypes">
      </nx-edit-select-input>
      <nx-edit-text-input
        formControlName="title"
        [placeholder]="'Titel hinzufügen'"
        label="Titel">
      </nx-edit-text-input>
      <nx-textfield-input
        formControlName="description"
        [showLabel]="false"
        [placeholder]="'Beschreibung hinzufügen'"
        label="Beschreibung">
      </nx-textfield-input>
    </div>
  `
})
export class TaskCreateDialogComponent implements EditDialogInstance {

  readonly ref = inject(DynamicDialogRef);
  readonly config = inject(DynamicDialogConfig);

  readonly selectableTaskTypes = [
    { id: 'nexcore_default_task', name: 'Allgemein', label: 'Allgemein' }
  ];

  readonly taskForm = new FormGroup({
    title: new FormControl<string | undefined>(undefined, Validators.required),
    description: new FormControl<string | undefined>(undefined),
    type: new FormControl<string>('nexcore_default_task'),
  });

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    const taskInput = new TaskInput();
    taskInput.title = this.taskForm.value.title;
    taskInput.description = this.taskForm.value.description;
    taskInput.type = this.taskForm.value.type;
    this.ref.close(taskInput);  
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.taskForm;
  }
}
